// const mazeSecrets = [{
//     text: "type xyz"
//     position: {column: 1}
// }]

// const maze = Array(20)
//   .fill(0)
//   .map((content, row) =>
//     Array(50)
//       .fill(0)
//       .map(
//         (columnContent, column) =>
//           `{{.[[${column * 2 + 1},${100 - row * 5},x]]}}`,
//       ),
//   )
//   .reduce(
//     (a, b) => `${a}
//   ${b}`,
//     "",
//   );
// export const maskOfAlthan = `
// {{The Rite of Subterfuge[[x,x,x]]}}
// ${maze}
// `;

export const maskOfAlthan = `
{{Thus speaks Althan[[x,x,x]]}}
{{My child, the life of pious depravity protects our soul from the grave injustice of servitude by giving us freedom from vulnerability.[[x,x,x]]}}
{{Hide by mask or hide by pen. Some say they are wise, as the Cordant believe, but they only replace truth with flowery words.[[x,x,x]]}}
{{SPEAK WELL and you will need never hide again.[[x,x,x]]}}
Let me bestow upon you the {{Quill of the Cordant[[100,x,x]]<<Quill of the Cordant>>}}
`;
